export default __webpack_public_path__ + "static/media/NotificacaoIconWhite.f05e0499.svg";